import { uuid } from "utils/utils";
import { State } from "./types";
import { deviceId } from "components/Signup/flow/utils/getDeviceId";
import { getSteps } from "components/Signup/steps";
import { getDefaultAnimal } from "./utils";

export const initialStateSwe: State = {
  metadata: {
    deviceId: deviceId(),
    sessionId: uuid(),
    purchaseCompleted: false,
    campaignCode: null,
    draftId: null,
    error: null,
    loading: false,
    isResumed: false,
    fromApp: false,
    returnUrl: null,
  },
  animals: [getDefaultAnimal()],
  customer: {
    address: {
      city: null,
      line1: null,
      zip: null,
    },
    privacyAccepted: false,
    marketingPermissionAccepted: false,
    termsAccepted: false,
    birthdate: null,
    email: null,
    firstName: null,
    lastName: null,
    phone: null,
    region: null,
    ssn: null,
    eurobonusMemberId: null,
    eurobonusMemberIdValid: true,
    lunarMemberId: null,
    lunarMemberIdValid: true,
    clientId: null,
  },
  navigation: {
    isTransitioning: false,
    activeStep: getSteps()[0].name,
    isValid: false,
  },
};
